export default {"src":"/_next/static/media/automotive.22eaeb1c.svg","height":121,"width":120};